import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { MarianomGeneral } from '../../components/marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'app-help-bar-mmax',
  templateUrl: './help-bar-mmax.component.html',
  styleUrls: ['./help-bar-mmax.component.scss']
})
export class HelpBarMmaxComponent implements OnInit {
  scroll: boolean = false;
  ruta: string;

  constructor(
    private serv: MarianomGeneral,
    private genServ: EcommerceGenericoService,
    private router: ActivatedRoute,
    public modal: ModalService
  ) {
    this.ruta = window.location.hash;
  }

  ngOnInit(): void { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.scroll = scrollPos > 40;
  }

  irAyuda() {
    this.ruta = window.location.hash;

    if (this.ruta === '#/checkout/finalizar') {
      this.modal.open('modal-completar-pago');
    } else {
      this.serv.gotoURL('checkout/ayuda', this.router);
    }
  }

  volver() {
    this.serv.navigator.goLandPage(this.router);
    this.serv.setMenuActivoNombre('landing');
  }

  get logosrc() {
    return this.genServ.getLogo();
  }

  iraLand() {
    this.ruta = window.location.hash;
    if (this.ruta === '#/checkout/finalizar') {
      this.modal.open('modal-completar-pago');
    } else {
      this.serv.navigator.goLandPage(this.router);
      this.serv.setMenuActivoNombre('landing');
      this.serv.cerrarUI();
    }
  }
}
